import { render, staticRenderFns } from "./AetnaDentalPage.vue?vue&type=template&id=fec413ce"
import script from "./AetnaDentalPage.vue?vue&type=script&lang=js"
export * from "./AetnaDentalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports